import React from 'react';
import Title from '../../../../../@casino/ui/title';
import { useDispatch, useSelector } from 'react-redux';
import { setGetMailing } from '../../../../store/mailing/thunk/setGetMailing';
import { useRouter } from '../../../../../@casino/useRouter';
import { setGetMailingUsers } from '../../../../store/mailing/thunk/setGetMailingUsers';
import { setUpdateMailing } from '../../../../store/mailing/thunk/setUpdateMailing';
import TabGeneral from '../../components/TabGeneral';
import TabStatistics from '../../components/TabStatistics';


const MailingView = () => {

    const router = useRouter();
    const dispatch = useDispatch();


    const [activeTab, setActiveTab] = React.useState('general')

    const {id} = router.query;

    React.useEffect(() => {
        dispatch(setGetMailing({
            id,
            page: 1,
            pageSize: 1
        }));
        dispatch(setGetMailingUsers({
            id,
            page: 1,
            pageSize: 25,
        }))
    }, []);

    const mailing = useSelector((state) => state.mailing.list?.data)?.[0] || {};

   

    return (
        <div style={{
            padding: '0 20px 20px',
        }}>
            <Title
                label="Рассылка"
            />
            <TabGeneral mailing={mailing} id={id} />
        </div>
    )
}

export default MailingView;